[
  {
    "items": 1,
    "bonus": 0,
    "premium": 200
  },
  {
    "items": 2,
    "bonus": 0,
    "premium": 400
  },
  {
    "items": 3,
    "bonus": 0,
    "premium": 600
  },
  {
    "items": 4,
    "bonus": 0,
    "premium": 800
  },
  {
    "items": 5,
    "bonus": 0,
    "premium": 1000
  }
]
